import { render } from "./FailedView.vue?vue&type=template&id=536b44e7"
import script from "./FailedView.vue?vue&type=script&lang=js"
export * from "./FailedView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__